import { render } from "./StageTreeBlock.vue?vue&type=template&id=f89638fc"
import script from "./StageTreeBlock.vue?vue&type=script&lang=js"
export * from "./StageTreeBlock.vue?vue&type=script&lang=js"

import "./StageTreeBlock.vue?vue&type=style&index=0&id=f89638fc&lang=css"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__